import React from 'react'
import PropTypes from 'prop-types'

import { Box, Flex } from '@chatterbug/aaron'
import UnitIcon from 'src/ui/UnitIcon/UnitIcon'
import ProgressBar from 'src/ui/ProgressBar/ProgressBar'
import { t } from 'src/lib/i18n-react'
import { shouldUnitBeGreyedOut } from 'src/utils/unit'

const UnitListItemInfo = React.memo(
  ({ iconUrl, name, topicName, progress, showProgressBar }) => {
    return (
      <Flex alignItems="center" flex={1}>
        {iconUrl && (
          <Box mr="3x" sx={{ flexShrink: 0 }}>
            <UnitIcon
              name={name}
              iconSize={72}
              iconUrl={iconUrl}
              isCompleted={progress?.isCompleted}
              shouldBeGreyedOut={shouldUnitBeGreyedOut(progress)}
            />
          </Box>
        )}

        <Flex flexDirection="column" flex={1}>
          {topicName && <Box variant="text.tinyTitle">{topicName}</Box>}
          <Box
            variant="text.h4"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {name}
          </Box>
          {showProgressBar &&
            (progress?.isSkipped && progress?.percentOfExercisesSeen == 0 ? (
              <Box variant="text.paragraph" fontSize="xxs" color="gray60">
                {t('Skipped unit')}
              </Box>
            ) : (
              <ProgressBar
                completeFraction={progress?.percentOfExercisesSeen}
                label={t('Live Lessons')}
              />
            ))}
        </Flex>
      </Flex>
    )
  }
)

UnitListItemInfo.propTypes = {
  iconUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  topicName: PropTypes.string,
  showProgressBar: PropTypes.bool,
  progress: PropTypes.shape({
    isQueued: PropTypes.bool,
    isCurrent: PropTypes.bool,
    isCompleted: PropTypes.bool,
    isSkipped: PropTypes.bool,
    exercises: PropTypes.string,
    percentOfExercisesSeen: PropTypes.number,
    flashcards: PropTypes.string,
    media: PropTypes.string,
    writing: PropTypes.string,
  }),
}

export default UnitListItemInfo
